import { get_token, get_user_details } from "@/router";
import Discussion from "@/components/DiscussionForum/DiscussionForum.vue";
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';

import { client_domain } from "@/main.js";
import pollMethods from './create_poll_methods';

export default {
    props: {
        is_public: {
            type: Boolean,
            default: false,
        },
        portal_admin: {
            type: Boolean,
            default: false,
        },
    },
    components: {
        Discussion,
        Sidebar,
        Navbar,
        InactivityModal,
    },
    mounted() {
        this.token_exists = get_token();
        this.user_id = this.get_user_id();
        this.user_details = get_user_details();
        this.get_question_types();
        this.filter_polls();

        this.fetch_questions();

        if (client_domain.includes('soulcity') || client_domain.includes('nsp')) {
            this.soulcity_domain = true;
        }
    },

    data() {

        return ({
            selectedPollId: null,
            token_exists: false,
            polls: [],
            poll_dashboard: {},
            poll_id: null,
            activeVoiceTab: 'discussions',
            poll_name: '',
            poll_question: '',
            poll_description: '',
            questions: [],
            showQuestionsForm: true,
            errors: [],
            answers: {},
            filteredQuestions: [],
            poll_poll_selectname: "",
            selectedQuestions: [],
            description: "",
            showQuestionForm: false,
            newQuestion: {
                text: '',
                question_number: '',
                type: '',
                options: [],
                is_mandatory: false,
            },
            question_types: [],
            showSelectedQuestions: false,
            createdQuestions: [],
            poll_questions: [],
            portal_id: null,
            expandedQuestions: new Map(),
            allowMultiple: false,
            options: [
                { value: '' },
                { value: '' },
                { value: '' }
            ],
            selectedPoll: null,
            selected_view_poll: null,
            numberErrors: {},
            soulcity_domain: false,
            user_details: {
                "user_role": '',
                "user_id": '',
            },
            openOptions: new Map(),
            flipped_id: null,
            isEditMode: false,
            isLoading: true,

        })
    },
    computed: {
        poll_dashboard_cards() {
            return [
                { label: 'Total Polls', value: this.get_poll_dashboard_value('total_count', this.polls.length), icon: 'bi-bar-chart-line-fill', tone: 'primary' },
                { label: 'Portal', value: this.get_poll_dashboard_value('portal_count'), icon: 'bi-grid-3x3-gap-fill', tone: 'info' },
                { label: 'Home', value: this.get_poll_dashboard_value('home_count'), icon: 'bi-house-fill', tone: 'success' },
                { label: 'Groups', value: this.get_poll_dashboard_value('group_count'), icon: 'bi-people-fill', tone: 'warning' },
                { label: 'Organization', value: this.get_poll_dashboard_value('organization_count'), icon: 'bi-building-fill', tone: 'secondary' },
                { label: 'Questions', value: this.get_poll_dashboard_value('total_questions'), icon: 'bi-question-circle-fill', tone: 'primary' },
                { label: 'Answers', value: this.get_poll_dashboard_value('total_answers'), icon: 'bi-chat-square-text-fill', tone: 'success' },
                { label: 'Respondents', value: this.get_poll_dashboard_value('unique_respondents'), icon: 'bi-person-check-fill', tone: 'info' },
            ];
        },
    },
    methods: {
initDataTable(id) {
      const table = $(id);

      if (!table.length) return;

      if ($.fn.DataTable.isDataTable(id)) {
        table.DataTable().destroy();
      }

      table.DataTable({
        paging: true,
        searching: true,
        ordering: true,
        info: true,
        lengthChange: true,
        pageLength: 10,
        language: {
          paginate: {
            previous: "Previous",
            next: "Next"
          },
          info: "Showing _START_ to _END_ of _TOTAL_ entries",
          infoEmpty: "No entries available"
        }
      });
    },
refresh_poll_table() {
      this.$nextTick(() => {
        this.initDataTable('#poll-table');
      });
    },
destroy_poll_table() {
      if ($.fn.DataTable.isDataTable('#poll-table')) {
        $('#poll-table').DataTable().destroy();
      }
    },
toggleSidebar() {
      if (!this.$refs.sidebar) return;
      this.$refs.sidebar.$el.classList.toggle("close");
    },
open_create_modal() {
      this.isEditMode = false;
      this.reset_poll_form();
      $('#create_poll').modal('show');
    },
open_edit_modal(poll) {
      this.isEditMode = true;
      this.poll_id = poll.id;
      this.poll_name = poll.name;
      this.poll_description = poll.description || '';

      const firstQuestion = this.get_edit_poll_question(poll);
      this.poll_question = firstQuestion?.question || '';
      this.allowMultiple = this.is_selection_question(firstQuestion);
      this.options = this.get_edit_poll_options(firstQuestion);

      $('#create_poll').modal('show');
    },
get_edit_poll_question(poll) {
      return poll?.poll_questions?.[0]?.question || {};
    },
is_selection_question(question) {
      return String(question?.question_type?.question_type || '').toLowerCase() === 'selection';
    },
get_edit_poll_options(question) {
      const options = (question?.options || [])
        .map(option => ({ value: option.option || option.value || option.text || '' }))
        .filter(option => option.value);

      return this.ensure_edit_poll_options(options);
    },
ensure_edit_poll_options(options) {
      const resolved_options = options.length
        ? options
        : [{ value: '' }, { value: '' }, { value: '' }];

      if (resolved_options[resolved_options.length - 1]?.value) {
        resolved_options.push({ value: '' });
      }

      return resolved_options;
    },
open_poll_responses_modal(poll) {
      this.selected_view_poll = poll;
      this.$nextTick(() => {
        $('#view_poll_responses_modal').modal('show');
      });
    },
get_poll_response_questions(poll = {}) {
      const selected_poll = poll || {};
      return selected_poll.poll_questions || selected_poll.questions || [];
    },
get_poll_response_question_text(poll_question = {}) {
      const selected_question = poll_question || {};
      const question = selected_question.question || selected_question;
      return this.get_response_text_value(question, ['question', 'text'], 'Question');
    },
get_poll_response_answer_text(answer = {}) {
      const selected_answer = answer || {};
      return this.get_response_text_value(selected_answer, ['answer', 'value', 'response'], 'No vote');
    },
get_response_user_name(answer = {}) {
      const selected_answer = answer || {};
      const user = selected_answer.user || {};
      return [user.first_name, user.last_name].filter(Boolean).join(' ') || 'Unknown User';
    },
get_response_text_value(source = {},
keys = [],
fallback = '') {
      const value = keys.map(key => Reflect.get(source, key)).find(Boolean);
      return value || fallback;
    },
getToken() {
            return get_token();
        },
get_user_id() {
            const user_id = localStorage.getItem('user_id') || '';
            return user_id;
        },
get_poll_dashboard_value(key,
fallback = 0) {
            const value = Reflect.get(this.poll_dashboard || {}, key);
            return [undefined, null, ''].includes(value) ? fallback : value;
        },
refresh_poll_dashboard_from_list() {
            this.poll_dashboard = {
                ...this.poll_dashboard,
                total_count: (this.polls || []).length,
            };
        },
fetch_questions() {
            this.token_exists = get_token();
            $.ajax({
                url: `${process.env.VUE_APP_BACKEND_API_URL}/membership_management/filter_questions/`,
                method: "POST",
                headers: this.token_exists
                    ? { Authorization: `Token ${this.getToken()}` }
                    : {},
                success: (response) => {
                    this.questions = response.data.questions;
                },
            });
        },
  ...pollMethods
}
};

